import GatsbyImage from 'common/components/GatsbyImage';
import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { PiCheckCircleFill } from 'react-icons/pi';
import Fade from 'react-reveal/Fade';
import Section, { Content, Features, Figure, Grid } from './analytics.style';

const AnalyticsTool = () => {
	const data = useStaticQuery(graphql`
		query {
			appJson {
				analyticsTool {
					features
					slogan
					title
					desc
				}
			}
			analytics: file(
				relativePath: { eq: "image/app/analytics.png" }
			) {
				childImageSharp {
					gatsbyImageData(
						layout: FULL_WIDTH
						placeholder: BLURRED
						formats: [AUTO, WEBP, AVIF]
					)
				}
			}
		}
	`);

	const { appJson: analyticsTool, analytics } = data;

	const { slogan, title, desc, features } = analyticsTool?.analyticsTool;

  return (
    <Section>
      <Container width="1400px">
        <Grid>
          <Figure>
          	<Fade up>
							<GatsbyImage
								src={
									analytics?.childImageSharp?.gatsbyImageData
										? analytics?.childImageSharp?.gatsbyImageData
										: {}
								}
								objectFit="contain"
								alt="Furbuz health dashboard showing pet weight chart, diet plan, and progress statistics"
							/>
          	</Fade>
          </Figure>
          <Content>
						<Text className="subtitle" content={slogan} />
						<Heading content={title} />
						<Text className="description" content={desc} />
						{features?.length > 0 ?
              <Features>
                {features?.map((feature) => (
                  <li key={feature}>
                    <PiCheckCircleFill aria-hidden="true" />
                    {feature}
                  </li>
                ))}
              </Features>
              :
              ""
            }
          </Content>
        </Grid>
      </Container>
    </Section>
  );
};

export default AnalyticsTool;
